import { useRequestLoaderContext } from 'applications/GSP/app/providers/PrefetchProvider/hooks';
import { Loader } from 'shared/components/Loader';

import {
  useGetUser,
  useGetSchool,
  useGetTranslation,
  useGetUserSettings,
} from './hooks';

import type { FC, PropsWithChildren as PrefetchProviderProps } from 'react';

export const Prefetch: FC<PrefetchProviderProps> = ({ children }) => {
  const [loadingStates] = useRequestLoaderContext();

  useGetTranslation();
  useGetUser();
  useGetSchool();
  useGetUserSettings();

  const isLoading = Object.values(loadingStates).some(
    loadingState => loadingState,
  );

  if (isLoading) {
    return <Loader />;
  }

  return <>{children}</>;
};
